(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mp-hero-rotation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mp-book-rotator')) {
  customElements.define('mp-book-rotator', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.mp-slide')];
      if (this.slides.length < 2 || this.ready) return;
      this.ready = true;
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovered = false;
      this.focused = false;
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.querySelector('.mp-rotation-controls').hidden = false;
      this.querySelector('[data-previous]').addEventListener('click', () => { this.show(this.index - 1); this.schedule(); }, opts);
      this.querySelector('[data-next]').addEventListener('click', () => { this.show(this.index + 1); this.schedule(); }, opts);
      this.querySelector('[data-pause]').addEventListener('click', () => { this.paused = !this.paused; this.syncPause(); this.schedule(); }, opts);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, opts);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, opts);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, opts);
      this.addEventListener('focusout', e => { if (!this.contains(e.relatedTarget)) { this.focused = false; this.schedule(); } }, opts);
      document.addEventListener('visibilitychange', () => this.schedule(), opts);
      this.motion.addEventListener('change', e => { this.paused = e.matches; this.syncPause(); this.schedule(); }, opts);
      this.show(0); this.syncPause(); this.schedule();
    }
    show(next) {
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { const active = i === this.index; slide.classList.toggle('is-active', active); slide.setAttribute('aria-hidden', String(!active)); slide.tabIndex = active ? 0 : -1; });
      this.querySelectorAll('[data-gradient]').forEach(layer => layer.classList.toggle('is-active', layer.dataset.gradient === this.slides[this.index].dataset.book));
      this.querySelector('[data-title-output]').textContent = this.slides[this.index].dataset.title;
      this.querySelector('[data-counter]').textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.slides.length).padStart(2, '0')}`;
    }
    syncPause() {
      const b = this.querySelector('[data-pause]');
      b.textContent = this.paused ? '▸' : 'Ⅱ'; b.setAttribute('aria-label', this.paused ? b.dataset.playLabel : b.dataset.pauseLabel); b.setAttribute('aria-pressed', String(this.paused));
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || this.focused || document.hidden) return;
      this.timer = setTimeout(() => { this.show(this.index + 1); this.schedule(); }, Number(this.dataset.interval) || 7000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.ready = false; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mp-release-spotlight"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mp-release-spotlight')) {
  customElements.define('mp-release-spotlight', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const button = this.querySelector('[data-motion-toggle]');
      button.hidden = false;
      button.addEventListener('click', () => {
        const paused = this.classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        button.querySelector('span').textContent = paused ? '▸' : 'Ⅱ';
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

})();
